import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { clearStoredGuestSession } from "../../utils/guestAuth";

/**
 * Guest 세션을 끝내고 첫 로그인 화면(`/login`)으로 보낸다.
 *
 * `/login`은 PublicRoute가 지키고 있고 Guest도 인증된 사용자로 취급해 `/home`으로
 * 되돌린다(`components/PublicRoute.tsx`). 따라서 이동 전에 세션을 먼저 비워야
 * 화면이 실제로 바뀐다. 순서를 바꾸면 로그인 화면이 보이지 않고 Home으로 튕긴다.
 *
 * 정본 로그인 화면은 `/login` 하나다. Studio 안에서 소셜 버튼만 따로 띄우면
 * Email/Password 같은 이후 추가 수단이 빠진 화면이 생긴다.
 */
export const useExitGuestToLogin = (): (() => Promise<void>) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return useCallback(async (): Promise<void> => {
    try {
      await logout();
    } finally {
      // legacy GuestAuthProvider가 되살리지 않도록 저장된 Guest도 함께 비운다.
      clearStoredGuestSession();
      navigate("/login", { replace: true });
    }
  }, [logout, navigate]);
};
